export default "__VITE_ASSET__DAEafB0x__"